import { Component,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectorRef,
  ChangeDetectionStrategy, inject, DestroyRef } from '@angular/core';
import { AppService } from '../../../app.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { Form5471TextinfoService } from '../form5471-textinfo/form5471-textinfo.service';
import * as _ from 'lodash-es';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-form5471-schedule-g',
    templateUrl: './form5471-schedule-g.component.html',
    styleUrls: ['./form5471-schedule-g.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class Form5471ScheduleGComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  modalTitle = 'Schedule G Other Information';
  irsF5471ScheduleGData: any[] = [];
  auto5 = false;
  showFormLoader = true;
  crudLoading = false;
  minimise = false;
  modal_name: string | null = null;

  rowData: any = {};
  filterParams: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};

  private isInitialized = false;
  private isLoading = false;

  constructor(
    private form5471Service: Form5471TextinfoService,
    private gtwSnackbarService: GtwSnackbarService,
    private cdr: ChangeDetectorRef,
    private appService: AppService,
    private globalServiceProvider: GlobalService,
    private workspaceService: WorkspaceService
  ) {}

  ngOnInit(): void {
    this.initializeFromServices();
    this.tryInit();
  }

  private initializeFromServices(): void {
    const activeScreen = this.workspaceService.workspaceFactory?.activeScreen || {};
    const activeScreenData = activeScreen?.data || {};
    const selectedRowData = activeScreenData?.selected?.rowData;
    const directRowData = activeScreenData?.rowData;
    const fallbackRowData = activeScreenData && !activeScreenData.selected ? activeScreenData : {};

    const rowData = this.extractObject(selectedRowData || directRowData || fallbackRowData);
    if (Object.keys(rowData).length > 0) {
      this.rowData = rowData;
    }

    const filterParams = this.extractObject(
      activeScreen?.filters?.getFilterParams?.() ||
      activeScreen?.filters?.getFilterParamsFromCache?.() ||
      {}
    );
    if (Object.keys(filterParams).length > 0) {
      this.filterParams = filterParams;
    }

    const urls = this.extractObject(this.globalServiceProvider.GENERAL_CONFIG || {});
    if (Object.keys(urls).length > 0) {
      this.GENERAL_CONFIG = { ...this.GENERAL_CONFIG, ...urls };
    }

    const header = this.extractObject(this.globalServiceProvider.global?.globalParams || {});
    if (Object.keys(header).length > 0) {
      this.globalService = { ...header };
    } else {
      this.globalService = {
        ...(this.globalService || {}),
        sso_id: this.appService.USER_SETTINGS?.user?.sso_id || ''
      };
    }
  }

  private extractObject(value: any): Record<string, any> {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
      return {};
    }
    return value;
  }

  private tryInit(): void {
    if (this.isInitialized || this.isLoading) return;

    this.initializeFromServices();

    if (
      this.rowData &&
      Object.keys(this.rowData).length > 0 &&
      this.GENERAL_CONFIG &&
      (this.GENERAL_CONFIG.base_url || this.GENERAL_CONFIG.api_url)
    ) {
      this.isLoading = true;
      this.modal_name = 'form5471-schedule-g';
      this.initLoadData();
    }
  }

  private getBaseUrl(): string {
    return this.GENERAL_CONFIG.base_url || this.GENERAL_CONFIG.api_url || '';
  }

  private getCorrectTaxYear(): string {
    return (
      this.filterParams?.tax_year ||
      this.rowData.TAX_YEAR ||
      this.globalService?.tax_year ||
      ''
    );
  }

  private getCorrectScenario(): any {
    if (this.filterParams?.scenario) return this.filterParams.scenario;
    if (this.globalService?.checkLockedbj) {
      try {
        const checkLocked = safeJsonInput<any>(this.globalService.checkLockedbj, null, 'form5471-schedule-g.parse1');
        if (Array.isArray(checkLocked) && checkLocked.length > 0 && checkLocked[0].scenario_key) {
          return checkLocked[0].scenario_key;
        }
      } catch (e) {}
    }
    return this.globalService?.scenario;
  }

  initLoadData(): void {
    this.showFormLoader = true;
    this.cdr.detectChanges();

    const params = {
      action_code: '2pql6p',
      tax_year: this.getCorrectTaxYear(),
      scenario: this.getCorrectScenario(),
      jcd_key: this.globalService?.jcd_key === '' || this.globalService?.jcd_key === undefined
        ? 250
        : this.globalService.jcd_key,
      irs_form_no: 'F5471',
      combination_key: this.rowData.HO_COMBINATION_KEY
    };

    // Use getScheduleICheckboxData for action_code 2pql6p (Schedule G load)
    this.form5471Service
      .getScheduleICheckboxData(this.getBaseUrl(), params, this.globalService, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (data: any) => {
          if (data.callSuccess === '1') {
            const jsonObject = data.jsonObject || [];
            this.irsF5471ScheduleGData = this.processScheduleGData(jsonObject);
            this.setAmt();
          } else {
            if (data.errorMessage) {
              this.gtwSnackbarService.openSnackBar(data.errorMessage, 'gtw-snackbar--red');
            } else {
              this.gtwSnackbarService.openSnackBar(
                'An error occurred. If you continue to experience this issue please visit the help page to contact support.',
                'gtw-snackbar--red'
              );
            }
          }
          this.showFormLoader = false;
          this.isLoading = false;
          this.isInitialized = true;
          this.cdr.detectChanges();
        },
        (error: any) => {
          console.error('Error loading Schedule G data:', error);
          this.showFormLoader = false;
          this.isLoading = false;
          this.gtwSnackbarService.openSnackBar(
            'An error occurred loading Schedule G data.',
            'gtw-snackbar--red'
          );
          this.cdr.detectChanges();
        }
      );
  }

  processScheduleGData(irsF5471ScheduleGData: any[]): any[] {
    const result: any[] = [];
    if (!irsF5471ScheduleGData || irsF5471ScheduleGData.length < 2) return result;

    let i = 1;
    let previous_line_no = irsF5471ScheduleGData[i]?.line_no;

    while (i < irsF5471ScheduleGData.length) {
      const tempObj: any = {};
      let j = i;
      let count = 0;

      while (
        j < irsF5471ScheduleGData.length &&
        previous_line_no === irsF5471ScheduleGData[j].line_no
      ) {
        const item = irsF5471ScheduleGData[j];
        const attribValueParts = (item.attrib_value || '').split('~');
        const objectIdParts = (item.object_id || '').split('~');
        const attribKey = attribValueParts[0];

        if (attribKey === 'LINE_NO') {
          tempObj.propertyType = item.PROPERTY_TYPE;
          tempObj.line_no = item.line_no;
          tempObj.parent_line_no = item.PARENT_LINE_NO;
          tempObj.col_id = item.COL_ID;
          tempObj.parent_col_id = item.PARENT_COL_ID;
          tempObj.line_type = item.LINE_TYPE;
          tempObj.saveParams = {
            tax_year: objectIdParts[0],
            trans_type_key: objectIdParts[1],
            trans_Details_key: objectIdParts[3],
            occurrence: objectIdParts[4],
            form_key: objectIdParts[6]
          };
        } else if (attribKey === 'LINE_DESCRIPTION') {
          tempObj.line_description = attribValueParts[3];
        } else if (
          attribKey === 'LINE_19_1_VALUE_5471' ||
          attribKey === 'LINE_14_1_VALUE_5471'
        ) {
          tempObj.propertyType1 = item.PROPERTY_TYPE;
          tempObj.isEditableFlag = 'Y';
          tempObj.isEditableFlagText = 'Y';
          tempObj.isSaveValidFlag = 'Y';
          tempObj.line_description1 = attribValueParts[3];
          tempObj.value_1 = {
            VALUE: item.VALUE,
            line_attrib_key: attribValueParts[1],
            attrib_name: attribValueParts[0]
          };
        } else if (
          attribKey === 'LINE_20_1_VALUE_5471' ||
          attribKey === 'LINE_15_1_VALUE_5471'
        ) {
          tempObj.propertyType1 = item.PROPERTY_TYPE;
          tempObj.isEditableFlag = 'Y';
          tempObj.isEditableFlagText = 'Y';
          tempObj.isSaveValidFlag = 'Y';
          tempObj.line_description2 = attribValueParts[3];
          tempObj.value_2 = {
            VALUE: item.VALUE,
            line_attrib_key: attribValueParts[1],
            attrib_name: attribValueParts[0]
          };
        } else if (
          attribKey === 'LINE_21_1_VALUE_5471' ||
          attribKey === 'LINE_16_1_VALUE_5471'
        ) {
          tempObj.propertyType1 = item.PROPERTY_TYPE;
          tempObj.isEditableFlag = 'Y';
          tempObj.isEditableFlagText = 'Y';
          tempObj.isSaveValidFlag = 'Y';
          tempObj.line_description3 = attribValueParts[3];
          tempObj.value_3 = {
            VALUE: item.VALUE,
            line_attrib_key: attribValueParts[1],
            attrib_name: attribValueParts[0]
          };
        } else if (attribKey === 'COMPARABLE_UNCONTROLLED_Y') {
          tempObj.value_comparable = {
            VALUE: item.VALUE,
            line_attrib_key: attribValueParts[1],
            attrib_name: attribValueParts[0],
            property_type: item.PROPERTY_TYPE
          };
        } else if (attribKey === 'INCOME_METHOD_Y') {
          tempObj.value_income = {
            VALUE: item.VALUE,
            line_attrib_key: attribValueParts[1],
            attrib_name: attribValueParts[0],
            property_type: item.PROPERTY_TYPE
          };
        } else if (attribKey === 'ACQUISITION_PRICE_METHOD_Y') {
          tempObj.value_acquisition = {
            VALUE: item.VALUE,
            line_attrib_key: attribValueParts[1],
            attrib_name: attribValueParts[0],
            property_type: item.PROPERTY_TYPE
          };
        } else if (attribKey === 'MARKET_CAPITALIZATION_Y') {
          tempObj.value_market = {
            VALUE: item.VALUE,
            line_attrib_key: attribValueParts[1],
            attrib_name: attribValueParts[0],
            property_type: item.PROPERTY_TYPE
          };
        } else if (attribKey === 'RESIDUAL_PROFIT_Y') {
          tempObj.value_residual = {
            VALUE: item.VALUE,
            line_attrib_key: attribValueParts[1],
            attrib_name: attribValueParts[0],
            property_type: item.PROPERTY_TYPE
          };
        } else if (attribKey === 'UNSPECIFIED_METHODS_Y') {
          tempObj.value_unspecified = {
            VALUE: item.VALUE,
            line_attrib_key: attribValueParts[1],
            attrib_name: attribValueParts[0],
            property_type: item.PROPERTY_TYPE
          };
        } else {
          if (count > 0) {
            if (count === 1) {
              tempObj.attrib_name = [tempObj.attrib_name];
              tempObj.value = [tempObj.value];
            }
            tempObj.attrib_name[count] = attribValueParts[0];
            tempObj.value[count] = {
              VALUE: item.VALUE,
              line_attrib_key: attribValueParts[1]
            };
          } else {
            tempObj.propertyType = item.PROPERTY_TYPE;
            tempObj.isEditableFlag = 'Y';
            tempObj.isSaveValidFlag = 'Y';
            tempObj.attrib_name = attribValueParts[0];
            tempObj.value = {
              VALUE: item.VALUE,
              line_attrib_key: attribValueParts[1]
            };
          }
        }

        previous_line_no = item.line_no;
        if (item.PROPERTY_TYPE == 13) count++;
        j++;
      }

      if (j < irsF5471ScheduleGData.length) {
        previous_line_no = irsF5471ScheduleGData[j].line_no;
      }
      result.push(tempObj);
      i = j;
    }

    return result;
  }

  private setAmt(): void {
    const params = {
      tax_year: this.getCorrectTaxYear(),
      scenario: this.getCorrectScenario(),
      combination_key: this.rowData.COMBINATION_KEY || this.rowData.HO_COMBINATION_KEY,
      jcd_key:
        this.globalService?.jcd_key === '' || this.globalService?.jcd_key === undefined
          ? 250
          : this.globalService.jcd_key
    };

    this.form5471Service
      .getScheduleIData(this.getBaseUrl(), params, this.globalService, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (data: any) => {
          if (data.callSuccess === '1' && data.jsonObject && data.jsonObject[0]) {
            const obj = data.jsonObject[0];
            const temp_amt = obj.SEC_901M_AMT;
            const temp_amt1 = obj.SEC_909_SUSP_TAX;
            const temp_amt2 = obj.SEC_909_TAX_RELEASED;
            const temp_value1 = obj.LINE_1 ?? null;
            const temp_value2 = obj.LINE_3 ?? null;
            const temp_value3 = obj.LINE_19 ?? null;

            // auto6 (line 17a): for tax years after 2019 legacy forces No and disables Yes.
            if (this.getCorrectTaxYear() > '2019') {
              this.setAutoRadioRow('auto6', false);
            }
            // auto1 (line 1) / auto2 (line 3): driven by LINE_1 / LINE_3.
            this.setAutoRadioRow('auto1', temp_value1 === 'Y');
            this.setAutoRadioRow('auto2', temp_value2 === 'Y');
            // auto3: section 901(m) amount; auto4: section 909 suspended taxes.
            this.setAutoRadioRow('auto3', temp_amt != 0);
            this.setAutoRadioRow('auto4', !!temp_amt1 && temp_amt2 != 0);

            const autoList5 = _.filter(this.irsF5471ScheduleGData, (p: any) =>
              _.includes(['auto5'], p.line_type)
            );

            if (autoList5 && autoList5.length > 0) {
              const value5 = this.irsF5471ScheduleGData.find(
                (x: any) => x.attrib_name === autoList5[0].attrib_name
              );
              if (value5 && value5.value) {
                if (temp_value3 === 'Y') {
                  value5.value[0].VALUE = 'Y';
                  value5.value[1].VALUE = null;
                  if (value5.value[1]) value5.value[1].disabled = true;
                  this.auto5 = true;
                } else {
                  value5.value[1].VALUE = 'N';
                  value5.value[0].VALUE = null;
                  if (value5.value[0]) value5.value[0].disabled = true;
                  if (value5.value_1) value5.isEditableFlagText = 'N';
                  value5.isSaveValidFlag = 'Y';
                  this.auto5 = true;
                }
              }
            }
          }
          this.cdr.detectChanges();
        },
        () => this.cdr.detectChanges()
      );
  }

  // Legacy setAmt() auto-fills the Yes/No radio for auto1-auto4/auto6 rows
  // (lines 1, 3, 901(m), 909, 17a) and disables the opposite option.
  private setAutoRadioRow(lineType: string, isYes: boolean): void {
    const row = this.irsF5471ScheduleGData.find((p: any) => p.line_type === lineType);
    if (!row || !Array.isArray(row.value) || !row.value[0] || !row.value[1]) {
      return;
    }
    if (isYes) {
      row.value[0].VALUE = 'Y';
      row.value[1].VALUE = null;
      row.value[1].disabled = true;
    } else {
      row.value[1].VALUE = 'N';
      row.value[0].VALUE = null;
      row.value[0].disabled = true;
    }
  }

  private runAllValidations(): void {
    for (let i = 0; i < this.irsF5471ScheduleGData.length; i++) {
      const row = this.irsF5471ScheduleGData[i];
      if (row.propertyType === 13 || row.propertyType === '13') {
        this.checkingForValidation(row, i, 'radio', true);
      }
      if (row.line_type === 'check') {
        this.checkingForValidation(row, i, 'checkbox', true);
      }
      if (
        row.propertyType === 7 ||
        row.propertyType === '7' ||
        row.line_type === 'auto5' ||
        row.line_type === 'a' ||
        row.line_type === 'b'
      ) {
        if (this.isAmountFieldDisabled(row)) {
          continue;
        }
        this.checkingForValidation(row, i, 'amount', true);
      }
    }
    this.cdr.detectChanges();
  }

  private isAmountFieldDisabled(row: any): boolean {
    if (row.line_type === 'auto5') {
      return this.auto5 === true || row.isEditableFlagText !== 'Y';
    }
    if (row.line_type === 'a' || row.line_type === 'b') {
      return row.isEditableFlagText !== 'Y';
    }
    if (row.propertyType === 7 || row.propertyType === '7') {
      return row.isEditableFlag === 'N';
    }
    return false;
  }

  showRadioError(row: any): boolean {
    return (
      (row.propertyType === 13 || row.propertyType === '13') &&
      row.isSaveValidFlag === 'N' &&
      !this.rowHasAmountField(row)
    );
  }

  showDescriptionColumnError(row: any): boolean {
    if (row.isSaveValidFlag !== 'N') {
      return false;
    }
    if (row.line_type === 'check') {
      return false;
    }
    if (row.propertyType === 13 || row.propertyType === '13') {
      return false;
    }
    if (row.propertyType === 7 || row.propertyType === '7') {
      return false;
    }
    if (row.line_type === 'auto5' || row.line_type === 'a' || row.line_type === 'b') {
      return false;
    }
    return true;
  }

  private rowHasAmountField(row: any): boolean {
    return (
      row.propertyType === 7 ||
      row.propertyType === '7' ||
      row.line_type === 'auto5' ||
      row.line_type === 'a' ||
      row.line_type === 'b'
    );
  }

  onRadioBtnSelection(row: any, _index: number, value: string): void {
    if (row.value) {
      if (value === 'Y') {
        row.value[0].VALUE = 'Y';
        row.value[1].VALUE = null;
      } else if (value === 'N') {
        row.value[0].VALUE = null;
        row.value[1].VALUE = 'N';
      }
    }
    this.cdr.detectChanges();
  }

  onCheckboxToggle(valueObj: any, event: Event): void {
    if (valueObj && event?.target) {
      const target = event.target as HTMLInputElement;
      valueObj.VALUE = target.checked ? '1' : '0';
    }
    this.cdr.detectChanges();
  }

  checkingForValidation(
    row: any,
    index: number,
    type: string,
    skipDetectChanges = false
  ): void {
    const data = this.irsF5471ScheduleGData;
    let occList: any[] = [];

    if (type === 'radio' && row.col_id !== '7') {
      occList = _.filter(data, (o: any) => o.parent_line_no === row.line_no);
    } else if (type === 'radio' && row.col_id === '7') {
      occList = _.filter(data, (o: any) =>
        o.line_type === 'check' || o.line_type === 'multi'
      );
    } else if (
      (type === 'radio' && row.line_no !== row.parent_line_no) ||
      type === 'amount' ||
      row.line_type === 'check'
    ) {
      occList = _.filter(data, (o: any) => o.line_no === row.line_no);
    }

    occList.forEach((currentObj: any) => {
      if (
        currentObj.line_no === currentObj.parent_line_no &&
        currentObj.col_id === currentObj.parent_col_id
      ) {
        return;
      }
      const attribute = currentObj.attrib_name;
      const col_id = currentObj.col_id;
      const parent_col_id = currentObj.parent_col_id;

      if (type === 'radio') {
        if (row.value?.[1]?.VALUE === 'N' && col_id === parent_col_id) {
          this.findIndexAndUpdate(data, attribute, 'N', 'Y');
        } else if (
          row.value?.[0]?.VALUE === 'Y' &&
          col_id === parent_col_id &&
          row.col_id !== '7'
        ) {
          this.findIndexAndUpdate(data, attribute, 'Y', 'N');
        } else if (row.value?.[1]?.VALUE === 'N' && col_id !== parent_col_id) {
          this.findIndexAndUpdate(data, attribute, 'N', 'Y');
        } else if (
          row.value?.[0]?.VALUE === 'Y' &&
          col_id !== parent_col_id &&
          row.line_type !== 'auto5'
        ) {
          this.findIndexAndUpdate(data, attribute, 'Y', 'N');
        } else if (
          row.value?.[0]?.VALUE === 'Y' &&
          col_id !== parent_col_id &&
          row.line_type === 'auto5'
        ) {
          this.findIndexAndUpdate(data, attribute, 'Y', 'Y');
        } else if (
          row.value?.[0]?.VALUE === 'Y' &&
          col_id === parent_col_id &&
          row.col_id === '7'
        ) {
          this.findIndexAndUpdate(data, attribute, 'Y', 'N', '7');
        } else if (
          (row.value?.[0]?.VALUE == null && row.value?.[1]?.VALUE == null) ||
          (row.value?.[0]?.VALUE === undefined && row.value?.[1]?.VALUE === undefined)
        ) {
          this.findIndexAndUpdate(data, attribute, 'Y', 'Y');
        }
      } else if (type === 'amount' && row.line_type !== 'check' && row.parent_line_no !== '7') {
        const validLine_no =
          row.parent_col_id === '10' ? currentObj.parent_col_id : currentObj.parent_line_no;
        const findLineNoData = data.find((x: any) => x.line_no === validLine_no);
        if (
          (findLineNoData?.value?.[0]?.VALUE == null && findLineNoData?.value?.[1]?.VALUE == null) ||
          (findLineNoData?.value?.[0]?.VALUE === undefined &&
            findLineNoData?.value?.[1]?.VALUE === undefined)
        ) {
          this.findIndexAndUpdate(data, attribute, 'Y', 'Y');
        } else {
          if (row.col_id === row.parent_col_id) {
            if (row.value?.VALUE != null && row.value?.VALUE !== undefined) {
              this.findIndexAndUpdate(data, attribute, 'Y', 'Y');
            }
            if (row.value?.VALUE == null || row.value?.VALUE === undefined) {
              this.findIndexAndUpdate(data, attribute, 'Y', 'N');
            }
            if (findLineNoData?.value?.[1]?.VALUE === 'N') {
              this.findIndexAndUpdate(data, attribute, 'N', 'Y');
            }
          }
          if (row.col_id !== row.parent_col_id) {
            const hasValue2 =
              row.value?.[0]?.VALUE === 'Y' &&
              row.value_2?.VALUE !== '' &&
              row.value_2?.VALUE != null;
            const hasValue3 =
              row.value?.[0]?.VALUE === 'Y' &&
              row.value_3?.VALUE !== '' &&
              row.value_3?.VALUE != null;
            if (hasValue2 || hasValue3) {
              this.findIndexAndUpdate(data, attribute, 'Y', 'Y');
            } else if (
              (row.value?.[0]?.VALUE === 'Y' &&
                (row.value_2?.VALUE === '' || row.value_2?.VALUE == null)) ||
              (row.value?.[0]?.VALUE === 'Y' &&
                (row.value_3?.VALUE === '' || row.value_3?.VALUE == null))
            ) {
              this.findIndexAndUpdate(data, attribute, 'Y', 'N');
            }
            if (row.value?.[1]?.VALUE === 'N') {
              this.findIndexAndUpdate(data, attribute, 'N', 'Y');
            }
          }
        }
      } else if (row.line_type === 'check') {
        const validLine_no = currentObj.parent_col_id;
        const findLineNoData = data.find((x: any) => x.line_no === validLine_no);
        if (
          (findLineNoData?.value?.[0]?.VALUE == null && findLineNoData?.value?.[1]?.VALUE == null) ||
          (findLineNoData?.value?.[0]?.VALUE === undefined &&
            findLineNoData?.value?.[1]?.VALUE === undefined)
        ) {
          this.findIndexAndUpdate(data, attribute, 'Y', 'Y');
        }
        const hasAny =
          (row.value_comparable?.VALUE != null && row.value_comparable?.VALUE !== '0') ||
          (row.value_acquisition?.VALUE != null && row.value_acquisition?.VALUE !== '0') ||
          (row.value_income?.VALUE != null && row.value_income?.VALUE !== '0') ||
          (row.value_market?.VALUE != null && row.value_market?.VALUE !== '0') ||
          (row.value_residual?.VALUE != null && row.value_residual?.VALUE !== '0') ||
          (row.value_unspecified?.VALUE != null && row.value_unspecified?.VALUE !== '0');
        const allZero =
          row.value_comparable?.VALUE === '0' ||
          row.value_acquisition?.VALUE === '0' ||
          row.value_income?.VALUE === '0' ||
          row.value_market?.VALUE === '0' ||
          row.value_residual?.VALUE === '0' ||
          row.value_unspecified?.VALUE === '0';
        const allNull =
          row.value_comparable?.VALUE == null &&
          row.value_acquisition?.VALUE == null &&
          row.value_income?.VALUE == null &&
          row.value_market?.VALUE == null &&
          row.value_residual?.VALUE == null &&
          row.value_unspecified?.VALUE == null;
        if (hasAny) {
          this.findIndexAndUpdate(data, attribute, 'Y', 'Y');
        }
        if (allZero) {
          this.findIndexAndUpdate(data, attribute, 'Y', 'N');
        }
        if (allNull) {
          this.findIndexAndUpdate(data, attribute, 'N', 'Y');
        }
        if (
          row.value_comparable?.VALUE === '1' ||
          row.value_acquisition?.VALUE === '1' ||
          row.value_income?.VALUE === '1' ||
          row.value_market?.VALUE === '1' ||
          row.value_residual?.VALUE === '1' ||
          row.value_unspecified?.VALUE === '1'
        ) {
          this.findIndexAndUpdate(data, attribute, 'Y', 'Y');
        }
      }
    });

    this.cdr.detectChanges();
  }

  private findIndexAndUpdate(
    data: any[],
    attribName: string,
    value: string,
    saveFlag: string,
    multiple?: string
  ): void {
    const findData = data.find((x: any) => x.attrib_name === attribName);
    if (!findData) return;

    if (findData.col_id === findData.parent_col_id) {
      findData.isEditableFlag = value;
      findData.isSaveValidFlag = multiple === '7' ? 'Y' : saveFlag;

      if (value === 'N') {
        findData.isEditableFlag = 'N';
        if (findData.value) findData.value.VALUE = null;
        if (findData.value_acquisition) findData.value_acquisition.VALUE = null;
        if (findData.value_comparable) findData.value_comparable.VALUE = null;
        if (findData.value_income) findData.value_income.VALUE = null;
        if (findData.value_market) findData.value_market.VALUE = null;
        if (findData.value_residual) findData.value_residual.VALUE = null;
        if (findData.value_unspecified) findData.value_unspecified.VALUE = null;
        if (findData.value?.[1]?.VALUE !== undefined) findData.value[0].VALUE = null;
      }
      if (findData.value?.[0]?.VALUE !== undefined) findData.value[1].VALUE = null;
    } else {
      findData.isEditableFlagText = value;
      findData.isSaveValidFlag = saveFlag;
      if (value === 'N') {
        if (findData.value_1) {
          findData.isEditableFlagText = 'N';
          findData.value_1.VALUE = null;
        }
        if (findData.value_2) findData.value_2.VALUE = null;
        if (findData.value_3) findData.value_3.VALUE = null;
        if (findData.value?.[0]) findData.value[0].VALUE = null;
        findData.isSaveValidFlag = 'Y';
      }
    }
  }

  checkingForValidSave(): boolean {
    for (let i = 0; i < this.irsF5471ScheduleGData.length; i++) {
      if (this.irsF5471ScheduleGData[i].isSaveValidFlag === 'N') {
        this.gtwSnackbarService.openSnackBar('Please check the below errors', 'gtw-snackbar--red');
        return false;
      }
    }
    return true;
  }

  saveScheduleGForm(): void {
    const scheduleSettings = [
      {
        tax_year: this.getCorrectTaxYear(),
        scenario: this.getCorrectScenario(),
        jcd_key: this.globalService?.jcd_key === '' || this.globalService?.jcd_key === undefined
          ? 250
          : this.globalService.jcd_key
      }
    ];

    if (!this.checkingForValidSave()) return;

    const editRow: any[][] = [];
    const temporaryObject = this.irsF5471ScheduleGData;

    for (let loopIndex = 0; loopIndex < temporaryObject.length; loopIndex++) {
      const row = temporaryObject[loopIndex];

      if (
        row.line_type === 'auto5' ||
        row.line_type === 'check' ||
        row.line_type === 'a' ||
        row.line_type === 'b'
      ) {
        for (const key in row) {
          if (!Object.prototype.hasOwnProperty.call(row, key)) continue;
          const obj = row[key];
          if (
            obj != null &&
            typeof obj === 'object' &&
            Object.prototype.hasOwnProperty.call(obj, 'attrib_name')
          ) {
            let val = obj.VALUE;
            if (row.line_no === '12' && obj.VALUE === '0') val = '';
            const saveObject = [
              {
                tax_year: this.getCorrectTaxYear(),
                trans_type_key: row.saveParams.trans_type_key,
                combination_key: this.rowData.HO_COMBINATION_KEY,
                group_obj_key: this.rowData.GROUP_OBJ_KEY,
                form_key: row.saveParams.form_key,
                line_no: row.line_no,
                occurence:
                  row.saveParams.occurrence === '0' ? null : row.saveParams.occurrence,
                line_attrib_key: obj.line_attrib_key,
                Attribute_Name: obj.attrib_name,
                Attribute_Value: val,
                trans_dtls_key:
                  row.saveParams.trans_Details_key === '0'
                    ? null
                    : row.saveParams.trans_Details_key,
                trans_status: 'A'
              }
            ];
            editRow.push(saveObject);
          }
        }
      }

      // Legacy uses a separate if (not else-if) so combo rows like 15/16
      // (line_type a/b + propertyType 13 radio) save both amount and Yes/No.
      if (row.propertyType == 13 && Array.isArray(row.attrib_name)) {
        for (let k = 0; k < row.attrib_name.length; k++) {
          const saveObject = [
            {
              tax_year: this.getCorrectTaxYear(),
              trans_type_key: row.saveParams.trans_type_key,
              combination_key: this.rowData.HO_COMBINATION_KEY,
              group_obj_key: this.rowData.GROUP_OBJ_KEY,
              form_key: row.saveParams.form_key,
              line_no: row.line_no,
              occurence:
                row.saveParams.occurrence === '0' ? null : row.saveParams.occurrence,
              line_attrib_key: row.value[k].line_attrib_key,
              Attribute_Name: row.attrib_name[k],
              Attribute_Value: row.value[k].VALUE,
              trans_dtls_key:
                row.saveParams.trans_Details_key === '0'
                  ? null
                  : row.saveParams.trans_Details_key,
              trans_status: 'A'
            }
          ];
          editRow.push(saveObject);
        }
      } else if (row.propertyType !== '0' && row.propertyType !== 0 && row.value) {
        const saveObject = [
          {
            tax_year: this.getCorrectTaxYear(),
            trans_type_key: row.saveParams.trans_type_key,
            combination_key: this.rowData.HO_COMBINATION_KEY,
            group_obj_key: this.rowData.GROUP_OBJ_KEY,
            form_key: row.saveParams.form_key,
            line_no: row.line_no,
            occurence:
              row.saveParams.occurrence === '0' ? null : row.saveParams.occurrence,
            line_attrib_key: row.value.line_attrib_key,
            Attribute_Name: row.attrib_name,
            Attribute_Value: row.value.VALUE,
            trans_dtls_key:
              row.saveParams.trans_Details_key === '0'
                ? null
                : row.saveParams.trans_Details_key,
            trans_status: 'A'
          }
        ];
        editRow.push(saveObject);
      }
    }

    if (!this.checkingForValidSave()) return;

    const scheduleDetails = { addrows: [], editrows: editRow, removerows: [] };
    this.crudLoading = true;
    this.cdr.detectChanges();

    this.form5471Service
      .saveForm5471ScheduleG(
        this.getBaseUrl(),
        scheduleSettings,
        scheduleDetails,
        this.globalService,
        this.filterParams
      ).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (result: any) => {
          this.crudLoading = false;
          if (result?.errorMessage && result.errorMessage !== 'null') {
            this.gtwSnackbarService.openSnackBar(result.errorMessage, 'gtw-snackbar--red');
          } else {
            this.gtwSnackbarService.openSnackBar(
              'Schedule G details successfully saved',
              'gtw-snackbar--green'
            );
            this.requestGridUpdate.emit('refresh');
          }
          this.cdr.detectChanges();
        },
        (error: any) => {
          this.crudLoading = false;
          this.gtwSnackbarService.openSnackBar(
            'Error saving Schedule G data. Please try again.',
            'gtw-snackbar--red'
          );
          this.cdr.detectChanges();
        }
      );
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }
}
